export default {
  'pages.login.failure': 'Login failed, please try again!',
  'pages.login.callbackError': 'Callback Error',
  'pages.login.success': 'Login successful!',
  'pages.login.azureButton': 'Azure AD Login',
  'pages.logout.success': 'Logout successful',
  'pages.logout.failure': 'Logout failure',
  'pages.404.subTitle': 'Sorry, the page you visited does not exist.',
  'pages.404.buttonText': 'Back Home',
};
